// extracted by mini-css-extract-plugin
module.exports = {"textDanger":"Lazada_textDanger__3b8K4","textBold":"Lazada_textBold__2wPrI","textSuccess":"Lazada_textSuccess__1XNWj"};